import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import { EigenwijsOptionSetup } from "widgets/configurator/eigenwijs-option-setup";
import { MobileDoorBasicLayoutsList } from "./MobileDoorBasicLayoutsList";
import { LayoutNavigationTransition } from "widgets/configurator/layout-navigation-transition";

export const MobileLayoutList = () => {
  const { layout, selfAssembleDoorData } = useConfigurationOptionsContext();
  const isEigenwijs = layout?.code === "eigenwijs";
  const layoutViewKey = isEigenwijs ? "eigenwijs" : "options";
  return (
    <LayoutNavigationTransition viewKey={layoutViewKey}>
      {isEigenwijs ? (
        <EigenwijsOptionSetup />
      ) : (
        <MobileDoorBasicLayoutsList
          showMeasurementInputs={!selfAssembleDoorData.selfAssembly}
        />
      )}
    </LayoutNavigationTransition>
  );
};
